import Vue from 'vue'
import './plugins'
import './plugins/i18n'
import autoTranslate from './plugins/autoTranslate'
import './registerServiceWorker'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'

import '@mdi/font/css/materialdesignicons.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fas)
library.add(fab)

Vue.config.productionTip = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL || ""
console.log(process.env.VUE_APP_API_URL)

// ── Le SW est enregistré automatiquement par le plugin PWA (via registerServiceWorker) ──
// Plus besoin de l'appel manuel ici.

autoTranslate.setCurrentPath((window.location.pathname || '') + (window.location.search || ''))
autoTranslate.prepareInitialPaint()

// ── Filtre truncate ──────────────────────────────────────────────
var filter = function (text, length, clamp) {
  clamp = clamp || '...'
  var node = document.createElement('div')
  node.innerHTML = text
  var content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}
Vue.filter('truncate', filter)

// ══════════════════════════════════════════════════════════════════
//  ONESIGNAL (si encore utilisé)
// ══════════════════════════════════════════════════════════════════
const ONESIGNAL_APP_ID = process.env.VUE_APP_ONESIGNAL_APP_ID || "0cf5a5c4-33af-433e-8b1d-e9fcc4694be3"

function initOneSignal() {
  if (typeof window.OneSignal === 'undefined') {
    console.log('🔔 Waiting for OneSignal...')
    setTimeout(initOneSignal, 1000)
    return
  }

  window.OneSignal = window.OneSignal || []

  window.OneSignal.push(function () {
    console.log('🔔 Initializing OneSignal (without Firebase)...')

    window.OneSignal.init({
      appId: ONESIGNAL_APP_ID,
      allowLocalhostAsSecureOrigin: true,
      autoRegister: true,
      notifyButton: { enable: false },
      serviceWorkerPath: 'push/onesignal/OneSignalSDKWorker.js',
      serviceWorkerUpdaterPath: 'push/onesignal/OneSignalSDKUpdaterWorker.js',
      serviceWorkerParam: { scope: '/push/onesignal/' },
      welcomeNotification: {
        disable: false,
        title: "Thanks for subscribing!",
        message: "You'll now receive notifications!"
      },
      notificationClickHandlerMatch: 'origin',
      notificationClickHandlerAction: 'focus',
      persistNotification: true,
      showCredit: false,
      path: '/',
      autoResubscribe: true
    })

    console.log('✅ OneSignal initialized (Firebase removed)')

    window.OneSignal.getNotificationPermission().then((permission) => {
      console.log('🔔 Permission status:', permission)
      if (permission === 'default') {
        console.log('🔔 Requesting permission...')
        window.OneSignal.registerForPushNotifications()
      }
    })

    window.OneSignal.isPushNotificationsEnabled().then((isEnabled) => {
      console.log('🔔 Push notifications enabled:', isEnabled)
      if (!isEnabled) {
        console.log('🔔 Attempting registration...')
        window.OneSignal.registerForPushNotifications()
      }
    })

    window.OneSignal.getUserId().then((userId) => {
      if (userId) {
        console.log("✅ Got OneSignal User ID:", userId)

        window.OneSignal.getSubscription().then((subscription) => {
          console.log("🔔 OneSignal Subscription details:", subscription)
        })

        const storedId = localStorage.getItem("onesignal_user_id")
        if (storedId !== userId) {
          axios.post("/api/v1/manager/save-onesignal-user-id/", {
            user_id: userId,
            device_type: "web"
          })
            .then(() => {
              console.log("✅ OneSignal ID saved to backend")
              localStorage.setItem("onesignal_user_id", userId)
            })
            .catch((err) => {
              console.error("❌ Failed saving OneSignal ID:", err)
            })
        }
      } else {
        console.warn("❌ No OneSignal User ID retrieved")
        console.log("🔔 Forcing registration...")
        window.OneSignal.registerForPushNotifications()
      }
    })

    window.OneSignal.on('subscriptionChange', function (isSubscribed) {
      console.log('🔔 Subscription changed:', isSubscribed)
      if (isSubscribed) {
        window.OneSignal.getUserId().then((userId) => {
          if (userId) {
            console.log("✅ New OneSignal User ID after subscription:", userId)
            localStorage.setItem("onesignal_user_id", userId)
          }
        })
      }
    })

    window.OneSignal.on('notificationClick', function (event) {
      console.log('📩 Notification clicked:', event)
      const data = event.data || {}
      if (data.url) {
        window.open(data.url, '_blank')
      } else {
        window.open('https://myapp.pettycashglobal.com/', '_blank')
      }
    })

    window.OneSignal.on('notificationDisplay', function (event) {
      console.log('📩 Notification DISPLAYED:', event)
    })

    window.OneSignal.on('notificationDismiss', function (event) {
      console.log('📩 Notification DISMISSED:', event)
    })

    setInterval(() => {
      window.OneSignal.isPushNotificationsEnabled().then((enabled) => {
        if (enabled) {
          console.log('🔔 Status check: Push notifications are enabled')
        } else {
          console.warn('⚠️ Status check: Push notifications are NOT enabled')
        }
      })
    }, 30000)
  })
}

window.testSystemNotification = function () {
  console.log('🧪 Testing system notification...')
  if ('Notification' in window) {
    if (Notification.permission === 'granted') {
      const notification = new Notification('Test System Notification', {
        body: 'This is a test notification from the system (no Firebase)',
        icon: '/favicon.ico'
      })
      notification.onclick = function () {
        console.log('System notification clicked')
        notification.close()
      }
      setTimeout(() => notification.close(), 5000)
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          window.testSystemNotification()
        }
      })
    }
  }
}

window.requestNotificationPermission = function () {
  console.log('🔔 Requesting OneSignal permission manually...')
  if (window.OneSignal) {
    window.OneSignal.registerForPushNotifications()
      .then(() => console.log('✅ OneSignal permission granted'))
      .catch((err) => console.error('❌ OneSignal permission denied:', err))
  }
}

initOneSignal()

// ══════════════════════════════════════════════════════════════════
//  WEBPUSH NATIF VAPID  (notifications messages chat)
// ══════════════════════════════════════════════════════════════════
const VAPID_PUBLIC_KEY = process.env.VUE_APP_VAPID_PUBLIC_KEY

function urlBase64ToUint8Array(base64String) {
  const pad = '='.repeat((4 - base64String.length % 4) % 4)
  const b64 = (base64String + pad).replace(/-/g, '+').replace(/_/g, '/')
  const raw = atob(b64)
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)))
}

function detectBrowser() {
  const ua = navigator.userAgent
  if (ua.includes('Firefox')) return 'firefox'
  if (ua.includes('Opera'))   return 'opera'
  return 'chrome'
}

function getCsrfToken() {
  return document.cookie
    .split(';')
    .map(c => c.trim())
    .find(c => c.startsWith('csrftoken='))
    ?.split('=')[1] ?? ''
}

async function initWebPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Service Worker non supporté');
    return false;
  }
  if (Notification.permission === 'denied') {
    console.warn('Notifications bloquées par l’utilisateur');
    return false;
  }

  try {
    // Le SW est déjà enregistré (par le plugin PWA), on attend qu'il soit prêt
    const reg = await navigator.serviceWorker.ready;

    if (Notification.permission !== 'granted') {
      const perm = await Notification.requestPermission();
      if (perm !== 'granted') {
        console.warn('Permission refusée');
        return false;
      }
    }

    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
    }

    const token = localStorage.getItem('token') || store.state.token || '';
    await axios.post('/api/v1/webpush/subscribe/', {
      status_type: 'subscribe',
      subscription: sub.toJSON(),
      group: 'chat_users',
      browser: detectBrowser(),
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
        'X-CSRFToken': getCsrfToken(),
      }
    });

    console.log('✅ Souscription WebPush envoyée à Django');
    navigator.serviceWorker.addEventListener('message', onSwMessage);
    return true;
  } catch (e) {
    console.warn('Erreur lors de la souscription:', e);
    return false;
  }
}

function onSwMessage(event) {
  if (event.data?.type !== 'JOUER_SON') return;
  jouerSon();
}

function jouerSon() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const sons = [
      [880, 0, 0.12],
      [660, 0.15, 0.12],
      [880, 0.3, 0.25],
    ];
    sons.forEach(([freq, start, dur]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = freq;
      osc.type = 'sine';
      gain.gain.setValueAtTime(0.7, ctx.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + dur);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + dur + 0.05);
    });
  } catch (e) {
    console.warn('Impossible de jouer le son:', e);
  }
}

window._initWebPush = initWebPush;

// ══════════════════════════════════════════════════════════════════
//  INSTANCE VUE
// ══════════════════════════════════════════════════════════════════
new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')